import { combineReducers } from 'redux';

import * as types from 'modules/audits/actionTypes';

import { DRAWER_PREVIEW_SOURCE } from 'modules/audits/constants';
import loading from 'modules/global/reducers/generic.loading';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/**
 * @typedef {{
 *   auditId: string
 *   loading: boolean,
 *   open: boolean,
 * }} AuditUIDrawerReducer
 */

export default combineReducers({
  auditId: createReducer(null, {
    [types.DRAWER_PREVIEW_OPEN]: (_, { payload: auditId }) => auditId,
    [types.DRAWER_PREVIEW_CLOSE]: () => null,
    [LOCATION_CHANGE]: () => null,
  }),
  loading: loading(types.FETCH_AUDIT_REQUEST, { global: { matcher: ({ meta }) => meta?.source === DRAWER_PREVIEW_SOURCE } }),
  open: createReducer(false, {
    [types.DRAWER_PREVIEW_OPEN]: () => true,
    [types.FETCH_AUDIT_FAILURE]: () => false,
    [types.DRAWER_PREVIEW_CLOSE]: () => false,
    [LOCATION_CHANGE]: () => false,
  }),
});
